import { render } from "./Tabla_botones.vue?vue&type=template&id=2cccb409&scoped=true"
import script from "./Tabla_botones.vue?vue&type=script&lang=js"
export * from "./Tabla_botones.vue?vue&type=script&lang=js"

import "./Tabla_botones.vue?vue&type=style&index=0&id=2cccb409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cccb409"]])

export default __exports__